import { render, staticRenderFns } from "./ActivityFlowCardItem.vue?vue&type=template&id=4885c4ac&scoped=true&"
import script from "./ActivityFlowCardItem.vue?vue&type=script&lang=js&"
export * from "./ActivityFlowCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFlowCardItem.vue?vue&type=style&index=0&id=4885c4ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885c4ac",
  null
  
)

export default component.exports